import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Компонент для управления прокруткой.
 * Работает в двух режимах:
 * 1. Если в state передано scrollTo — скроллит к элементу.
 * 2. Иначе — скроллит в самый верх.
 */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // 1. Проверяем, передано ли ID для скролла через state (чистые ссылки)
    const scrollToId = location.state?.scrollTo;

    if (scrollToId) {
      // Небольшая задержка, чтобы DOM успел обновиться
      const timer = setTimeout(() => {
        const element = document.getElementById(scrollToId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
        
        // Очищаем state, чтобы при обновлении страницы (F5) не скроллило повторно
        window.history.replaceState({}, document.title);
      }, 100);
      
      return () => clearTimeout(timer);
    } 
    
    // 2. Стандартный скролл вверх при переходе на новую страницу
    window.scrollTo(0, 0);
  }, [location.pathname, location.state]);

  return null;
}